<template>
  <div class="flex flex-col justify-between min-h-full">
    <Hero />
    <breadcrumbs :crumbs="breadcrumbs"/>
    <div v-if="taxon">
      <Taxon :taxon="taxon" />
      <Article
        :article="article"
        v-for="article in taxon.articles"
        :key="article.id"
      />
      <div v-for="t in taxon.children" :key="t.id">
        <div class="mb-2 knowledge-list-heading">{{ t.name }}</div>
        <Article
          :article="article"
          v-for="article in t.articles"
          :key="article.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Hero from "@/components/knowledge/Hero";
import Taxon from "@/components/knowledge/Taxon";
import Article from "@/components/knowledge/Article";

export default {
    name: "TaxonArticles",
    methods: mapActions({
        "fetchTaxon": "knowledge/taxons/fetchTaxon"
    }),
    computed: mapGetters({
        "taxon": "knowledge/taxons/taxon",
        "breadcrumbs": "knowledge/taxons/breadcrumbs"
    }),
    mounted() {
    	this.fetchTaxon({slug: this.$route.params.slug});
    },
    components: { Taxon, Hero, Article }
};
</script>
<style>
.bb-view-background {
  background: var(--knowledge-background);
}
</style>
